import { ReactNode } from 'react'

export interface Task {
  id: string
  completed?: boolean
}

export interface OnboardingChecklistTaskProps extends Task {
  step?: number
  title?: ReactNode
  group_id?: string
  icon?: ReactNode
  loading?: boolean
  onClick?: () => void
  disabled?: boolean
}

export interface OnboardingChecklistProps {
  completed: boolean
  tasks: OnboardingChecklistTaskProps[]
}

export interface OnboardingChecklistProgressProps {
  completed?: boolean
  total: number
  completedTotal: number
  appBarDark?: boolean
}

export interface OnboardingChecklistProps {
  check_demo_map?: boolean | undefined
  build_first_map?: boolean | undefined
  browse_data_explorer?: boolean | undefined
  browse_do_catalog?: boolean | undefined
  invite_your_colleagues?: boolean | undefined
  build_first_workflow?: boolean | undefined
}

export enum TaskList {
  Onboarding = 'onboarding',
  SnowflakePartnerConnect = 'sf-partner-connect',
  AIAgent = 'ai-agent'
}

export enum Video {
  WORKSPACE = 'workspace',
  BUILDER = 'Builder',
  WORKFLOWS = 'Workflows',
  AIAGENT = 'aiagent'
}
